import React, { useState, useEffect } from "react";

export default function UtcToLocal({utcTimestamp, options}) {
    const [localTimestamp, setLocalTimestamp] = useState("");

    // this format for only date
    // const options = {
    //     weekday: 'short',
    //     day: 'numeric',
    //     month: 'short',
    //     year: 'numeric',
    // };
    //
    // this format for date and time
    // const options = {
    //     weekday: 'short',
    //     day: 'numeric',
    //     month: 'short',
    //     year: 'numeric',
    //     hour: 'numeric',
    //     minute: 'numeric',
    //     hour12: true
    // };

    useEffect(() => {
        const getTimezone = async () => {
            const { timeZone } = await Intl.DateTimeFormat().resolvedOptions();
            setLocalTimestamp(new Date(Date.parse(utcTimestamp)).toLocaleString("en-US", {...options, timeZone}));
        };
        getTimezone();
    }, [utcTimestamp]);

    return <div>{localTimestamp!=="Invalid Date"?localTimestamp:  utcTimestamp }</div>;
}


// import React, { useState } from "react";
//
//  const UtcToLocal = () => {
//
//     const getTimezone = async (utcTimestamp) => {
//         const { timeZone } = await Intl.DateTimeFormat().resolvedOptions();
//         return new Date(Date.parse(utcTimestamp)).toLocaleString("en-US", { timeZone });
//     };
//
//     return {
//         getTimezone
//     };
// }
//
// export default UtcToLocal;